import React, { Component } from 'react'
import { connect } from "react-redux"
import SocialButton from './socailbutton';
import {socialLogin, addToast} from "../../actions"
import {ajaxerrmsg} from "../../actions/http"

class Login extends Component {

    constructor(props){
        super(props);
        this.handleFbLogin = this.handleFbLogin.bind(this);
        this.handleGoogleLoginFailure = this.handleGoogleLoginFailure.bind(this);
        this.handleFbLoginFailure = this.handleFbLoginFailure.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.client = Math.random() * 10000;
    }

    handleFbLogin(user){
        this.props.socialLogin(false, {
            access_token: user._token.accessToken,
            client: this.client
        });
    }

    handleGoogleLogin(user){
        this.props.socialLogin(true, {
            access_token: user._token.idToken,
            client: this.client
        });
    }
       
    handleGoogleLoginFailure(){
        this.props.addToast("Unable to access google", false);
    }

    handleFbLoginFailure(){
        this.props.addToast("Unable to access facebook", false);        
    }

    componentDidUpdate(prevProps){
        let {user, addToast} = this.props;
        if(user.error && !prevProps.user.error){
            addToast(ajaxerrmsg(user.error), false);
        }   
    }

    render() {
        return (
            <ul className="loginsection flex-center flex-wrap">
                <li className="m-b-10">
                    <SocialButton
                        google={false}
                        provider='facebook'
                        appId='336443297161712'
                        onLoginSuccess={this.handleFbLogin}
                        onLoginFailure={this.handleFbLoginFailure} 
                    />
                </li>
                <li className="m-b-10">
                    <SocialButton
                        google={true}
                        provider='google'
                        appId='476327743966-4olvqc3vofjfvvc0t079klvigkmqbrq0.apps.googleusercontent.com'
                        onLoginSuccess={this.handleGoogleLogin}
                        onLoginFailure={this.handleGoogleLoginFailure} 
                    />
                </li>
            </ul>
        )
    }
}

const mapStateToProps = ({loginReducer}) => ({ user: loginReducer })

const mapDispatchToProps = {socialLogin, addToast}


export default connect(mapStateToProps, mapDispatchToProps)(Login);
